import './App.css';
import React from 'react';
import { HashRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Article from './pages/Article/Article';
import QRScanner from './pages/QRScanner/QRScanner';

const App = () => {
  return (
    <Router>
      <div>
        <nav className="menu">
          <Link to="/">Home</Link>
          <Link to="/about">About Me</Link>
        </nav>
        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/article/:slug" element={<Article />} />
            <Route path="/qr-scanner" element={<QRScanner />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;